// src/config.ts

export const GRAPHQL_ENDPOINT =
  process.env.REACT_APP_GRAPHQL_ENDPOINT || "http://localhost:3000/graphql";

export const ADMIN_TOKEN_KEY = "hs_admin_token";
export const API_BASE_URL = GRAPHQL_ENDPOINT.replace(/\/graphql$/, "");

// ✅ NEW: R2 / CDN host (public)
export const ASSET_HOST = process.env.REACT_APP_ASSET_HOST || "";

// Small helper to avoid double slashes
const joinUrl = (base: string, path: string) =>
  `${base.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;

export const buildImageUrl = (path: string): string => {
  if (!path) return "";

  // already absolute
  if (path.startsWith("http://") || path.startsWith("https://")) return path;

  // ✅ If it's your uploads path, serve from R2 (preferred)
  if (ASSET_HOST && path.startsWith("/uploads/")) {
    return joinUrl(ASSET_HOST, path);
  }

  // fallback (old behavior)
  return `${API_BASE_URL}${path}`;
};

export const WHATSAPP_PHONE = process.env.REACT_APP_WHATSAPP_PHONE;

export const WHATSAPP_DEFAULT_MESSAGE =
  process.env.REACT_APP_WHATSAPP_MESSAGE ||
  "Assalam-o-Alaikum! I want to know more about your products.";

export function toProductSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}
